import React, { useCallback, useEffect, useRef, useState } from "react";
import { columns, filters, searchBy } from "../../../service/AUItemService";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";
import StoreModal from "../../../Components/Modals/StoreModal/StoreModal";
import ReferralModal from "../../PromotionManagement/Refferal/ReferralModal";
import MenuApi from "../../../App/api/menu.apis";
import { ApproveUnapproveApi } from "../../../App/api/a&uApi";
import { toast } from "react-toastify";
import CustomModal from "../../../custom/modal/customModal";
import CommonRejectTemplate from "../../../Components/CommonRejectTemplate";
import ItemDetails from "../../../Components/ProductModal/ItemDetails";
import { approvalStatusApi } from "../../../App/api/multilevelApproval.api";

const AUItemComponent = ({ pagination, handlePagination }) => {
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);

  const [isOrderDetail, setIsOrderDetail] = useState(false);
  const [selectedData, setSelectedProduct] = useState(null);
  const [isProductDetail, setIsProductDetail] = useState(false);
  const [vendorData, setVendorData] = useState(null);
  const [productData, setProductData] = useState(null);
  const [isRejectItemModalOpen, setIsRejectItemModalOpen] = useState(false);
  const [actionData, setActionData] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState(null);


  const getAllProduct = async () => {
    try {
      const approvalStatus = await approvalStatusApi.getAllApprovalStatuses({
        filter: { component: "Product" },
      });
      setApprovalStatus(approvalStatus?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }
    try {
      const res = await MenuApi.item.getAllItemProduct(pagination, search);
      setProductData(res?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const handleCloseVenderModal = () => {
    setIsOrderDetail(false);
    setSelectedProduct(null);
  };
  const handleRowClick = (row) => {
    setSelectedProduct(row);
    setIsOrderDetail(true);
  };
  const handleCellClick = async (row, action) => {
    if (action === "product") {
      // navigate(`/app/product-details/${row._id}`);
      setSelectedProduct(row);
      setIsProductDetail(true);
    }

    if (action === "Rejected") {
      setIsRejectItemModalOpen(true);
      setSelectedProduct(row);
      setActionData(action);
    } else if (action === "Approved") {
      setIsProductDetail(true);
      setSelectedProduct(row);

    
    }
    if (action === "order_id") {
      setSelectedProduct(row);
      setIsOrderDetail(true);
    }
    if (action === "vendor") {
      setVendorData(row);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
  };
  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllProduct();
  }, [pagination, search]);

  return (
    <div className="p-5">
      <BasicTable
        columns={columns}
        data={productData?.products}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: productData?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: productData?.totalPages || 1,
          totalCount: productData?.totalCount || 1,
        }}
        onCellClick={(e) => {
          console.log("Cell Data", e);
        }}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        filters={filters}
        selectedData={selectedData}
        handleCellClick={handleCellClick}
      />
      <ItemDetails
        open={isProductDetail}
        close={() => {
          setIsProductDetail(false);
          setSelectedProduct(null);
        }}
        approvalStatus={approvalStatus}
        setIsProductDetail={setIsProductDetail}
        getAllProduct={getAllProduct}
        data={selectedData}
      />
     
      <CustomModal
        isOpen={isRejectItemModalOpen}
        onClose={() => setIsRejectItemModalOpen(false)}
        title="Reject Item"
      >
        <CommonRejectTemplate
          data={selectedData}
          actionData={actionData}
          name={selectedData?.name}
          getAllData={getAllProduct}
          endpoint={ApproveUnapproveApi.updateItemApprovalStatus}
          closeModal={setIsRejectItemModalOpen}
          component="Product"
          approvalStatus={approvalStatus}
        />
      </CustomModal>
    </div>
  );
};

export default AUItemComponent;
